import SearchField from "../SearchField/SearchField";
import USQSFormGroup from "./USQSFormGroup";
import useUSQS from "../../hooks/useUSQS";
import useUSQSUndo from "../../hooks/useUSQSUndo";
import useAuth from "../../hooks/useAuth";
import { handleInputSelect, addEdits } from "./utils/inputhandlers";

const QSUSAInCharge = ({ clearfield }) => {
  // Load context values
  const { auth } = useAuth();
  const { USQS, setUSQS, setUSQSData } = useUSQS();
  const { USQSEdits, editIDUSQS, setEditIDUSQS, undoListUSQS } = useUSQSUndo();

  // Local function to allow shorthand input property for onItemSelect
  const localHandleInputSelect = (item, origin, destination) => {
    handleInputSelect(
      item,
      USQSEdits,
      editIDUSQS,
      setEditIDUSQS,
      setUSQS,
      setUSQSData,
      addEdits,
      undoListUSQS,
      origin,
      destination
    );
  };

  return (
    <fieldset>
      <legend>In Charge:</legend>
      <div className='form-group'>
        <label>Trader:</label>
        {auth?.role === 2020 ? (
          <SearchField
            required={true}
            searchURL='/api/users/gettraderlist'
            value={USQS?.trader || ""}
            valueName='trader'
            valueID='traderID'
            style={{ width: "90%" }}
            customplaceholder='Select TIC'
            onItemSelect={(item) => {
              localHandleInputSelect(item, "trader", "trader");
            }}
            clearfield={clearfield}
          />
        ) : (
          <USQSFormGroup readOnly={true} labelname={"Trader"} inputname={"trader"} />
        )}
      </div>
      <div className='form-group'>
        <label>Traffic:</label>
        <SearchField
          required={true}
          searchURL='/api/users/gettrafficlist'
          value={USQS?.traffic || ""}
          valueName='traffic'
          valueID='trafficID'
          style={{ width: "90%" }}
          customplaceholder='Select Traffic'
          onItemSelect={(item) => {
            localHandleInputSelect(item, "traffic", "traffic");
          }}
          clearfield={clearfield}
        />
      </div>
    </fieldset>
  );
};

export default QSUSAInCharge;
